import defaultAvatar from "../../assets/logo/logo.png";
import { API_BASE_URL } from "../../services/api";
import "../../styles/modal.css";

export default function ClientDetailsModal({ client, onClose }) {
  if (!client) return null;

  const user = client.user;

  const avatar = user?.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${user.profilPicture}`
    : defaultAvatar;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <img src={avatar} alt="avatar" className="modalAvatar" />
          <div>
            <div className="modalName">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="modalRole">Client</div>
              <div className="modalDins">Insrit le {new Date(user?.created_at).toLocaleString("fr-FR", {
                dateStyle: "medium",
                timeStyle: "short",
              })}</div>  

          </div>
          <button className="modalClose" onClick={onClose}>
            ✕
          </button>
        </div>
        {/* <div className="modalSection">
          <div className="modalSectionTitle">Documents</div>

          <div className="licenceGrid">
            <LicenceCard label="Licence (Recto)" image={client.licenceFront} />
            <LicenceCard label="Licence (Verso)" image={client.licenceBack} />
          </div>
        </div> */}
        <div className="modalSection">
          <div className="modalSectionTitle">Informations générales</div>
          <div className="modalGrid">
            <Info label="Username" value={user?.username} />
            <Info label="Solde" value={`${client.balance} CFA`} />
            {/* <Info
              label="Statut"
              value={client.isApproved ? "Approuvé" : "Non approuvé"}
            />
            <Info
              label="Disponibilité"
              value={client.isActive ? "Actif" : "Inactif"}
            /> */}
            {/* <Info
              label="Date D'inscription"
              value={new Date(client.created_at).toLocaleString("fr-FR", {
               dateStyle: "medium",
               timeStyle: "short",
              })}
            /> */}
            {/* {client?.updated_at
          ? (Number.isNaN(new Date(client.updated_at).getTime())
              ? "-"
              : new Date(client.updated_at).toLocaleString("fr-FR", {
                  dateStyle: "medium",
                  timeStyle: "short",
                }))
          : "-"} */}
          </div>
        </div>

        <div className="modalSection">
          <div className="modalSectionTitle">Contact</div>
          <div className="modalGrid">
            <Info label="Téléphone" value={user?.contact?.tel} />
            <Info label="Email" value={user?.contact?.email} />
            <Info label="WhatsApp" value={user?.contact?.whatsapp} />
            {/* <Info label="Adresse" value={user?.contact?.adress} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="infoItem">
      <span className="infoLabel">{label}</span>
      <span className="infoValue">{value || "-"}</span>
    </div>
  );
}

// function LicenceCard({ label, image }) {
//   const src = image
//     ? `${API_BASE_URL.replace("/api", "")}/images/driverLicence/${image}`
//     : null;

//   return (
//     <div className="licenceCard">
//       <span className="infoLabel">{label}</span>

//       {src ? (
//         <a href={src} target="_blank" rel="noreferrer">
//           <img src={src} alt={label} />
//         </a>
//       ) : (
//         <div className="licenceEmpty">Non fournie</div>
//       )}
//     </div>
//   );
// }
